import { __awaiter, __generator } from "tslib";
import { createSway, getSwayOptions } from '@office-start/sway-service';
import { logError } from '@office-start/telemetry-service';
import { appendQuery } from '@office-start/url-parser-utility';
import { launchUrlWrapper } from './launchUrlWrapper';
export function createNewSway(candidate, createOptions, createLink) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var url, fallbackForAAD, swayOptions, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    url = '';
                    fallbackForAAD = false;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 6, , 7]);
                    if (!candidate.canCreateBlankDocument) return [3 /*break*/, 5];
                    return [4 /*yield*/, getSwayOptions(createOptions.componentContext, createOptions.identity)];
                case 2:
                    swayOptions = _b.sent();
                    if (!swayOptions) return [3 /*break*/, 4];
                    return [4 /*yield*/, createSway(swayOptions)];
                case 3:
                    url = _b.sent();
                    return [3 /*break*/, 5];
                case 4:
                    fallbackForAAD = candidate.canFallbackToLandingPage;
                    _b.label = 5;
                case 5:
                    // If user is MSA or AAD fallback scenario (i.e.canFallbackToLandingPage set as true )
                    if (((_a = createOptions.identity) === null || _a === void 0 ? void 0 : _a.isMsa) || fallbackForAAD) {
                        if (!createLink || !createLink.url) {
                            return [2 /*return*/, { type: "Error" /* CreateDocumentResultType.Error */ }];
                        }
                        url = appendQuery(createLink.url, 'campaign=OHPCreateNew');
                    }
                    if (url) {
                        return [2 /*return*/, launchUrlWrapper(url, createOptions.targetTab, createOptions.newDocLinkTarget)];
                    }
                    return [2 /*return*/, { type: "Error" /* CreateDocumentResultType.Error */ }];
                case 6:
                    error_1 = _b.sent();
                    logError({
                        eventName: 'Sway_CreateNew_Error',
                        message: error_1,
                    });
                    return [2 /*return*/, { type: "Error" /* CreateDocumentResultType.Error */ }];
                case 7: return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=createNewSway.js.map